// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	6819: 0,
	2519: 0,
	7599: 0,
	6981: 0,
	8919: 0,
	4221: 0,
	4760: 0,
	1654: 0,
	1310: 0,
	2352: 0,
	1843: 0,
	8713: 0,
	8988: 0,
	4950: 0,
	2130: 0,
	7652: 0,
	3349: 0,
	5907: 0,
	3846: 0,
	2084: 0,
	3026: 0,
	5328: 0,
	8308: 0,
	2554: 0,
	3546: 0,
	3469: 0,
	1507: 0,
	7562: 0,
	780: 0,
	1216: 0,
	5182: 0,
	9277: 0,
	2295: 0,
	590: 0,
	2200: 0,
	2504: 0,
	8038: 0,
	6436: 0,
	8573: 0,
	6447: 0,
	2864: 0,
	3538: 0,
	9388: 0,
	1562: 0,
	8348: 0,
	6716: 0,
	6682: 0,
	5629: 0,
	4295: 0,
	4551: 0,
	7481: 0,
	5565: 0,
	7163: 0,
	6583: 0,
	9364: 0
};

// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = globalThis["webpackChunkvortexsolution"] = globalThis["webpackChunkvortexsolution"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));